import {Injectable} from '@angular/core';
import {ApiClientHelper} from '../helpers/api-client.helper';
import {AppConfig} from '../../shared/config/app-config';
import {Subject} from 'rxjs';
import {
	CashInsurance,
	CashInsuranceSubscription,
	CashInsuranceSubscriptionContent,
	InsuranceSubscription,
	Subscription
} from '../../shared/models/insurance.model';
import {StringHelper} from '../helpers/strings.helper';

@Injectable()
export class InsuranceService {

	private subscriptions: Subscription [] = [];
	private claim: string;
	private cashInsuranceDetails: CashInsuranceSubscriptionContent;
	private agentCashInsuranceSubscriptionId: number;
	private _destroySubscriptionModal = new Subject<any>();
	_destroySubscriptionModal$ = this._destroySubscriptionModal.asObservable();

	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
	) {

	}

	setCashInsuranceDetails(details: CashInsuranceSubscriptionContent) {
		this.cashInsuranceDetails = details;
	}

	getCashInsuranceDetails() {
		return this.cashInsuranceDetails;
	}

	setAgentCashInsuranceSubscriptionId(id) {
		this.agentCashInsuranceSubscriptionId = id;
	}

	getAgentCashInsuranceSubscriptionId() {
		return this.agentCashInsuranceSubscriptionId;
	}

	checkForUnsubscribedTerminal(): Promise<InsuranceSubscription> {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/insurance/subscription`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAgentInsurance(params): Promise<CashInsuranceSubscription> {
		params = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/cash-insurance/subscription/agent/get-subscriptions?${params}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getClaimInstruction(param): Promise<any> {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/cash-insurance/plan/claim-instruction/${param}`;
		return this.apiClientHelper.getForPromise(url);
	}

	getLogClaim(param): Promise<any> {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/cash-insurance/subscription/agent/claim-status/${param}`;
		return this.apiClientHelper.getForPromise(url);
	}

	subscribeForCashInsurance(params): Promise<any> {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/cash-insurance/subscription/agent/subscribe`;
		return this.apiClientHelper.postForPromise(url, params);
	}

	subscribeForCashInsuranceNewApi(params): Promise<any> {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/insurance/subscription/insure/${params
			.insurancePlanId}`;
		return this.apiClientHelper.postForPromise(url, {});
	}

	purchaseInsuranceSubscription(): Promise<any> {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/insurance/subscription/purchase`;
		return this.apiClientHelper.postForPromise(url, {});
	}

	deActivateSubscription(param) {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/cash-insurance/subscription/agent/de-activate/${param}`;
		return this.apiClientHelper.putForPromiseI(url, {});
	}

	getAvailableInsurance(): Promise<CashInsurance[]> {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/cash-insurance/plan/available`;
		return this.apiClientHelper.getForPromise(url);
	}

	getSubscription() {
		return this.subscriptions;
	}

	destroyModal() {
		this._destroySubscriptionModal.next(true);
	}

	setSubscription(subscriptions: Subscription[]) {
		this.subscriptions = subscriptions;
	}

	setClaim(claim: string) {
		this.claim = claim;
	}

	getClaim() {
		return this.claim;
	}

	claimInsurance(params): Promise<any> {
		const url = this.config.MONIEPOINT_INSURANCE + `/api/v1/cash-insurance/subscription/agent/log-claim`;
		return this.apiClientHelper.newPostAsFormDataForPromise(url, params);
	}
}
